import { useState, useEffect, ChangeEvent, FormEvent } from "react";
import { handleLogin } from "../services/auth";
import { navigate } from "gatsby";
import { FormInitialState, FormValidateError } from "../types/form";

const useFormValidation = (
  initialState: FormInitialState,
  validation: CallableFunction
) => {
  const [values, setValues] = useState<FormInitialState>(initialState);
  const [errors, setErrors] = useState<FormValidateError>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [missCount, setMissCount] = useState(0);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0;
      if (noErrors) {
        handleLogin(
          values,
          setErrors,
          () => {
            setIsSubmitting(false);
            navigate(`/app/`);
          },
          () => {
            setMissCount((prev) => prev + 1);
            if (missCount > 3) {
              setErrors({
                id:
                  "パスワードを忘れた場合はクラス担任経由でお問い合わせ下さい",
                password:
                  "パスワードを忘れた場合はクラス担任経由でお問い合わせ下さい",
              });
            } else {
              setErrors({
                id: "学籍番号またはパスワードが違います",
                password: "学籍番号またはパスワードが違います",
              });
            }
          },
          signal
        );
      } else {
        setIsSubmitting(false);
      }
    }

    return function cleanup() {
      abortController.abort();
    };
  }, [errors]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleBlur = () => {
    const validationError = validation(values);
    setErrors(validationError);
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const validationError = validation(values);
    setErrors(validationError);
    setIsSubmitting(true);
  };

  return { handleChange, handleSubmit, handleBlur, values, errors };
};

export default useFormValidation;
